var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"honeypot",on:{"click":function($event){return _vm.naviagteToHoneymoon()}}},[_c('img',{attrs:{"src":require("../assets/honey_pot.png"),"alt":"Honeymoon Fund themed Honey Pot"}})])}
var staticRenderFns = []

export { render, staticRenderFns }